import { useLocation } from 'react-router-dom';
import { useForm, SubmitHandler, } from 'react-hook-form';
import { useState } from 'react';
import styles from './PostDetail.module.scss';
import {Alert, Snackbar } from '@mui/material'

interface PostInterface {
    id: number;
    title: string;
    date: string;
    abstract: string;
    content: string;
}

interface CommentFormInputs {
    name: string;
    email: string;
    comment: string;
}

export default function PostDetails() {
    const location = useLocation();
    const { post } = location.state as { post: PostInterface };

    const [open, setOpen] = useState<boolean>(false);

    
    const { register, handleSubmit, formState: { errors } } = useForm<CommentFormInputs>();
        const onSubmit: SubmitHandler<CommentFormInputs> = (data) => {
        setOpen(true); 
        // *********fazer a logica de email se der tempo********
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <h1>{post.title}</h1>
                <p>{post.date}</p>
            </div>
            <p>{post.content}</p>

            
            <div>
            <h2>Deixe seu comentário</h2>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div>
                    <label htmlFor="name">Nome:</label>
                    <input
                        id="name"
                        type="text"
                        {...register('name', { required: 'Nome é obrigatório' })}
                    />
                    {errors.name && <p>{errors.name.message}</p>}
                </div>

                <div>
                    <label htmlFor="email">Email:</label>
                    <input
                        id="email"
                        type="email"
                            {...register('email', { 
                                required: 'Email é obrigatório', 
                                pattern: { value: /^\S+@\S+$/i, message: 'Email inválido' } 
                            })}
                    />
                    {errors.email && <p>{errors.email.message}</p>}
                </div>

                <div>
                    <label htmlFor="comment">Comentário:</label>
                    <textarea
                        id="comment"
                        {...register('comment', { required: 'Comentário é obrigatório' })}
                    />
                    {errors.comment && <p>{errors.comment.message}</p>}
                </div>

                <button type="submit">Enviar Comentário</button>
            </form>

            <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
                <Alert onClose={handleClose} severity="success">
                    Comentário enviado com sucesso!
            </Alert>
            </Snackbar>
        </div>
        </div>
    );
}
